// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueBus from 'vue-bus'
import {ClientTable} from 'vue-tables-2'
import axios from 'axios'
import VueAxios from 'vue-axios'
import swal from 'sweetalert'
import VueClipboard from 'vue-clipboard2'
import swAlert from 'sweetalert2'

window.sweetAlert = swal
window.swAlert = swAlert

window.Vue = Vue

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(ClientTable)
Vue.use(VueBus)

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective)

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js